import { POST } from '@/api'

const DEFAULT_SCT = {
  jp:
    '▽販売事業者名\n株式会社●●●\n\n▽代表者名\n●● ●●\n\n▽業務の責任者\n（例）購入店舗にご確認下さい。\n\n▽販売事業者所在地\n●● ●●\n\n▽電話番号\n●● ●●\n\n▽販売価格\n（例）当サイトで表示された商品代金（表示価格）による販売\n\n▽商品代金の支払い方法および支払い時期\n（例）商品お引渡し時に、店頭でお支払いください。\n（例）ご利用可能支払い方法は「現金」「クレジットカード（VISA/MasterCard）」「●●Pay」です。\n\n▽商品代金以外に必要な費用\n（例）箱代として、別途●●円が必要となります。\n\n▽商品の引き渡し時期\n（例）ご指定いただいた受取店舗及び日時から1時間以内にお引き取りをお願いいたします。\n（例）お客様のご都合によりお引き渡しができなかった場合は、商品代金の返金には応じられませんので、予めご了承ください。\n\n▽返品・交換について\n（例）商品の性質上、お客様のご都合での返品はお断りさせていただきます。\n（例）万一、商品に不備があった場合またはご注文内容と異なる商品であった場合は、直ちに購入店舗に直接お電話にてご連絡ください。\n\n▽商品に数量制限等ある場合\n（例）販売数量に制限がある場合は数量を明記します。\n\n▽申込みの期間\n（例）●●年●月●日まで申し込み可能\n（例）週末限定のお弁当は金曜日の午前中までにお申し込みください。',
  en:
    '▽Business name\n●●● Corp.\n\n▽Representative’s name\n●● ●●\n\n▽Manager’s name\nex. Please ask that to the restaurant.\n\n▽Address of the business\n●● ●●\n\n▽Phone number\n●● ●●\n\n▽Price\nex. We offer our items for the price presented on this website.\n\n▽Payment methods and payment deadline\nex. Please pay at the restaurant when picking up.\nex. Payment methods: cash, credit card(VISA/MasterCard), ●●Pay\n\n▽Charges except for items\nex. We charge ●●yen for a package.\n\n▽Available time for pick-up\nex. Please visit the restaurant you have chosen in 1 hour from the time you reserve to pick your order up.\nex. If you unfortunately cannot receive items you ordered, please note that we cannot pay the charge back.\n\n▽About refund and exchange\nex. Items cannot be refunded or exchanged due to the nature of the items.\nex. In case you purchased defective items or items you did not order, please call the restaurant. We will exchange them.\n\n▽About a purchasing limit\nex. We offer a purchasing limit as needed.\n\n▽Application Deadline\nex. You can apply by MM DD YYYY.',
}

export default {
  namespaced: true,
  state: {
    contents: null,
    lang: null,
    busy: false,
  },
  mutations: {
    set(state, value) {
      state.lang = value.lang
      state.contents = value.contents
    },
    update(state, contents) {
      state.contents = contents
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  actions: {
    get(store, lang) {
      const { commit, rootState } = store
      commit('set', { lang, contents: rootState.reception.sct[lang] || DEFAULT_SCT[lang] })
    },
    async save(store) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const payload = { sct: { [state.lang]: state.contents } }

      const { status, message } = await POST('/api/web/reception/sct/update', payload)

      if (status === 200) {
        commit('reception/sct/set', payload, { root: true })
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
